export default "__VITE_ASSET__DrksLBg1__"